<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class=""
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="green lighten-1"
                dark
                flat
              >
                <v-toolbar-title>Sign Up</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    label="Email"
                    name="email"
                    type="email"
                    id="email"
                    v-model="email"
                    autocomplete="email"
                    :rules="[
                        v => !!v || 'E-mail is required',
                        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                        ]"
                  ></v-text-field>
                  <v-text-field
                    label="Name"
                    name="name"
                    type="text"
                    id="name"
                    v-model="name"
                    :rules="[
                        v => !!v || 'Name is required',
                        ]"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    v-model="password"
                    autocomplete="new-password"
                    :rules="[v => !!v || 'Password is required']"
                  ></v-text-field>
                  <v-text-field
                    id="confirmPassword"
                    label="Confirm Password"
                    name="confirmPassword"
                    type="password"
                    v-model="confirmPassword"
                    autocomplete="new-password"
                    :rules="[
                      v => !!v || 'Confirm password is required',
                      v => v && v==password || 'Passwords must match'
                    ]"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn dark to="/login" color="green lighten-1">Log In</v-btn>
                <v-spacer></v-spacer>
                <v-btn :dark="valid" :disabled="!valid" @click="signup({username: email, password: password, name: name})" color="green lighten-1">Sign Up!</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// import { mapState } from "vuex";
import { mapActions } from "vuex";
import Parse from "parse";

export default {
  data() {
    return {
      valid: true,
      email: "",
      name: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    ...mapActions(['signup'])
  },
  computed: {
    // ...mapState([])
  },
};
</script>
